import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section data-id="element-227">
      <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-228">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-12 text-center leading-tight" data-id="element-229">
          Escucha lo que dicen nuestros estudiantes
        </h2>

        <div className="max-w-4xl mx-auto text-center" data-id="element-230">
          <QuoteIcon className="h-12 w-12 md:h-16 md:w-16 text-red-400 mx-auto mb-6 opacity-50" data-id="element-231" />
          <p className="text-lg md:text-xl text-gray-400 italic" data-id="element-232">
            Los testimonios de nuestros estudiantes se compartirán durante la
            masterclass en vivo.
          </p>
        </div>
      </div>
    </section>;
}